import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Driver } from '../state/types'

export const useDriverLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList, find } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllDrivers = (active = false) => getList(TableName.DRIVERS, active) as Driver[]

        const findDriver = (id?: string) => find(TableName.DRIVERS, id) as O<Driver>

        const loadAllDrivers = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.DRIVERS, options)
            return response.dataTypes as Driver[]
        }

        const loadDriver = (id: string, dbRequest = false) => {
            const { load } = loaders(companyId)
            return load(TableName.DRIVERS, id, dbRequest) as Promise<Driver>
        }

        return {
            findAllDrivers,
            findDriver,
            loadAllDrivers,
            loadDriver
        }
    }
}
